import { IconDevices } from "@tabler/icons-react"
import { type FC, lazy, Suspense } from "react"
import { useTheme } from "styled-components"

import AspectRatio from "@forento/ui/components/AspectRatio"

import PartialLoadingPage from "~/components/PartialLoadingPage"

import { AnalyticsCard, AnalyticsCardHeader } from "./shared"

const ResponsivePie = lazy(() => import("@nivo/pie").then(module => ({ default: module.ResponsivePie })))

const Devices: FC<{ devices: { label: string; visitsShare: number }[] }> = ({ devices }) => {
	const { primaryColor } = useTheme()

	const colors = [primaryColor, "#F6BE4F", "#80D3FF", "#DCDCDC"]
	const data = devices.map(device => ({
		id: device.label,
		label: device.label,
		value: device.visitsShare,
	}))

	return (
		<AnalyticsCard gridArea="devices" className="flex flex-col gap-6">
			<AnalyticsCardHeader Icon={IconDevices} title="Devices" />
			{devices.every(device => device.visitsShare === 0) ? (
				<p className="text-sm text-gray-500">No device data</p>
			) : (
				<div className="flex flex-wrap items-center justify-between gap-8">
					<AspectRatio aspectRatio={1} width={{ unit: "percent", value: 38 }}>
						<Suspense fallback={<PartialLoadingPage />}>
							<ResponsivePie
								data={data}
								colors={colors}
								innerRadius={0.75}
								cornerRadius={10}
								enableArcLabels={false}
								enableArcLinkLabels={false}
								isInteractive={false}
								margin={{ top: 2, right: 2, bottom: 2, left: 2 }}
							/>
						</Suspense>
					</AspectRatio>
					<div className="flex min-w-36 flex-1 flex-col gap-3">
						{devices.map((device, index) => (
							<div key={device.label} className="flex items-center gap-2">
								<div
									className="h-1.5 w-5 rounded-sm"
									style={{ backgroundColor: colors[index % colors.length] }}
								/>
								<div className="text-sm">{(device.visitsShare * 100).toFixed(2).padStart(5, "0")}%</div>
								<div className="text-sm">{device.label}</div>
							</div>
						))}
					</div>
				</div>
			)}
		</AnalyticsCard>
	)
}

export default Devices
